import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=91c7cba6&scoped=true&"
import script from "./Choice.vue?vue&type=script&lang=ts&"
export * from "./Choice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c7cba6",
  null
  
)

export default component.exports